import { useTranslation } from '@/shared/i18n/use-translation';
import { formatCents } from '@/shared/lib/money/format-cents';
import type { ShoppingItem } from '../schemas/shopping-item';

type ShoppingPriceProps = {
  readonly item: ShoppingItem;
};

/** The estimate while pending (≈), the real price once bought. */
export function ShoppingPrice({ item }: ShoppingPriceProps) {
  const { t } = useTranslation();
  const pending = item.status === 'pending';
  const price = pending ? item.estimated_price_cents : (item.price_cents ?? item.estimated_price_cents);
  return (
    <span className="text-sm font-medium tabular-nums">
      {price == null ? t('Not estimated') : `${pending ? '≈ ' : ''}${formatCents(price)}`}
    </span>
  );
}
